import { render, staticRenderFns } from "./SettingTabsChild.vue?vue&type=template&id=50ff8704&scoped=true&"
import script from "./SettingTabsChild.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SettingTabsChild.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SettingTabsChild.vue?vue&type=style&index=0&id=50ff8704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff8704",
  null
  
)

export default component.exports